const social = {
  github: "https://github.com/Nate-Potter",
  youtube: "https://www.youtube.com",
  chatgpt: "https://chat.openai.com/chat",
  amazon: "https://www.amazon.com",
};

export default social;
